import { render } from "./CarouselResultados.vue?vue&type=template&id=0d927fed"
import script from "./CarouselResultados.vue?vue&type=script&lang=js"
export * from "./CarouselResultados.vue?vue&type=script&lang=js"

import "./CarouselResultados.vue?vue&type=style&index=0&id=0d927fed&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__